import { MainButton } from "../../components/MainButton";
import { COLORS } from "../../utils/colors";

const BASE_URL = process.env.REACT_APP_SERVER;

export const OnboardingOrgPage = () => {
  return (
    <div id="container">
      <div id="heading-container">
        <h1>Organizer Onboarding</h1>
        <p>
          Welcome to ooval! In the following we will integrate your business
          with our payment process: Stripe. <br></br> This will help us to
          forward you your earnings
        </p>
        <div id="heading-cta-container">
          <div></div>
          <MainButton
            onClickAction={() =>
              window.open(`${BASE_URL}/onboard-organizer`, "_blank").focus()
            }
            text={"Setup payouts on Stripe"}
            color={COLORS.lightNeon}
            textColor={COLORS.black}
          />
        </div>
        <div
          style={{
            marginTop: "19vh",
          }}
        ></div>
      </div>
    </div>
  );
};
